<template>
  <el-dialog :visible.sync="visible" :title="this.dataForm.studentName+'争章详情'" :close-on-click-modal="false" :close-on-press-escape="false" width="80%" :append-to-body="true">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'"></el-form>
    <el-tabs v-model="dataForm.decorationId" tab-position="left" @tab-click="handleClick">
      <el-tab-pane v-for="decoration in this.decorationTypeList"  :key="decoration.decorationId" :label="decoration.decorationName" :name="decoration.decorationId">

        <el-table v-loading="dataListLoading" :data="studentTaskList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">

      <el-table-column prop="taskTitle" label="标题" header-align="center" align="center"></el-table-column>
      <el-table-column prop="taskContent" label="任务内容" header-align="center" align="center"></el-table-column>
      <el-table-column prop="imgSrc" label="任务图片" header-align="center" align="center">
        <template slot-scope="scope">
          <el-image v-for="src in scope.row.imgList" :key="src" @click.stop="handleClickItem" :preview-src-list="scope.row.imgList" style="width: 100px; height: 100px" :src="src" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="taskExplain" label="任务说明" header-align="center" align="center"></el-table-column>

      <el-table-column prop="isTask" label="任务状态" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isTask === 0">未编辑</el-tag>
          <el-tag v-else-if="scope.row.isTask === 1">已完成</el-tag>
          <el-tag v-else-if="scope.row.isTask === 2">完成待提交</el-tag>
          <el-tag v-else-if="scope.row.isTask === 3">提交审核中</el-tag>
          <el-tag v-else-if="scope.row.isTask === 4">退回</el-tag>
        </template>
      </el-table-column>
    </el-table>
      </el-tab-pane>
    </el-tabs>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>

</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import debounce from 'lodash/debounce'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/decoration/studentTermTable/page',
        getDataListIsPage: true,
        exportURL: '/decoration/termTable/export',
        deleteURL: '/decoration/termTable',
        deleteIsBatch: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      visible: false,
      termList: [],
      typeId: '',
      typeList: [],
      grades: [],
      classList: [],
      studentTaskList: [],
      decorationTypeList: [],
      gradeDecorationList: [],
      dataForm: {
        termId: '',
        studentId: '',
        decorationId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        termId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        openingObjectGroup: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getDecorationTypeList()
      // this.$nextTick(() => {
      //   this.getTaskList()
      // })
    },
    handleClick (tab) {
      this.dataForm.decorationId = tab.name
      this.getDecorationTypeList()
    },
    beforeQuery () {
      if (this.dataForm.gradeId !== '' && this.dataForm.classId !== '') {
        this.getThisGradeDecoration()
        this.query()
      }
    },
    getDecorationTypeList () {
      this.$http.get('decoration/studentDecoration/getDecorationList', {
        params: {
          studentId: this.dataForm.studentId,
          termId: this.dataForm.termId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.decorationTypeList = res.data
        console.log(this.dataForm.decorationId)
        if (this.dataForm.decorationId == 0 && res.data.length > 0) {
          this.dataForm.decorationId = res.data[0].decorationId
        }
        this.getTaskList()
      })
    },
    getTaskList () {
      this.$http.get('decoration/studentTask/getTaskListApp', {
        params: {
          studentId: this.dataForm.studentId,
          termId: this.dataForm.termId,
          decorationId: this.dataForm.decorationId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.studentTaskList = res.data
      })
    },
    changeType (type) {
      console.log(type)
      this.typeId = type.id
      this.query()
    },
    // changeDecorationType (type) {
    //   console.log(type)
    //   this.dataForm.decorationTypeId = type.id
    //   this.query()
    // },
    // 获取信息
    getInfo () {
      this.$http.get('/decoration/termtable/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    handleClickItem () {
      this.$nextTick(() => {
        const domImageMask = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.termName = this.termList.filter((e) => { return e.id === this.dataForm.termId })[0].termName
        this.$http[!this.dataForm.id ? 'post' : 'put']('/decoration/termTable/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
